import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {Ellipsis} from "../../../../core/components/misc/ellipsis/ellipsis";

export class StandingsWidgetCompetitorDestinationProps extends BaseProps {
  row: StandingsDestinationViewModel;
}

export const StandingsWidgetCompetitorDestination = observer(({row}: StandingsWidgetCompetitorDestinationProps) => {
  const {destination, destinationGuaranteed} = row;

  const destinationProps = {
    text: destination?.guaranteedText,
    numOfMaxLines: 2,
    className: classNames(styles.competitor_destination),
    style: {
      color: destination?.color
    },
  }

  return destinationGuaranteed ? <Ellipsis {...destinationProps}/> : null
});
